import { useState, useEffect, Fragment, ChangeEvent, useRef } from "react";
import { useQuery } from "react-query";
import { developAxios } from "../../axios.config";
import { Pagination } from "react-bootstrap";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Store } from "react-notifications-component";
import "./styles/EditQuiz.css";
import { useHistory, useLocation } from "react-router-dom";
import useContextMenu from "./context/useContextMenu";
import { ContextMenu } from "./styles/ContextMenu.styled";
import Select, { SingleValue, Options } from "react-select";
import moment from "moment-timezone";

const steps = ["Select Courses and Quizs", "Edit Quiz Data"];

let languageValues: Array<{
	value: "" | "DI/LR" | "Quant" | "Verbal";
	label: string;
}> = [
	{ value: "", label: "Select Language" },
	{ value: "Quant", label: "Quant" },
	{ value: "Verbal", label: "Verbal" },
	{ value: "DI/LR", label: "DI/LR" },
];

interface IQuizData {
	_id: string;
	examName: string;
	questions: Array<string>;
	category: string;
	timer: string;
	description: string;
	courseId: string;
	attempts: number;
	typeOfExam: "assignment" | "Test";
	company: string;
	type: string;
	locked: boolean;
	displayResult: boolean;
	outOfScore: number;
	language?: "DI/LR" | "Quant" | "Verbal" | "";
	examDate?: string;
	examEndTime?: string;
}

const QuizEditPage = () => {
	const urlParams = useRef(new URLSearchParams(window.location.search));
	const history = useHistory();
	const location = useLocation();
	const [currPage, setCurrPage] = useState(0);
	const [activeStep, setActiveStep] = useState(0);
	const [skipped, setSkipped] = useState(new Set());
	const [course, setCourse] = useState<null | {
		value: string;
		label: string;
	}>(null);
	const [courses, setCourses] = useState<
		Options<{
			value: string;
			label: string;
		}>
	>([]);
	const [quizId, setQuizId] = useState<null | {
		value: string;
		label: string;
	}>(null);
	const [quizData, setQuizData] = useState<
		Options<{
			value: string;
			label: string;
		}>
	>([]);
	const [quizQuestions, setQuizQuestions] = useState<Array<string>>([]);
	const [searchFilter, setSearchFilter] = useState<string>("");
	const [language, setLanguage] = useState<{
		value: "DI/LR" | "Quant" | "Verbal" | "";
		label: string;
	} | null>({
		value: "",
		label: "No Language Selected",
	});
	const [quizDataEdit, setQuizDataEdit] = useState<IQuizData>({
		attempts: 0,
		category: "",
		company: "",
		description: "",
		examName: "",
		timer: "0",
		type: "",
		typeOfExam: "assignment",
		courseId: "",
		locked: false,
		outOfScore: 0,
		questions: [],
		displayResult: false,
		language: "",
		_id: "",
	});
	const { clicked, setClicked, points, setPoints } = useContextMenu();

	const isStepSkipped = (step: number): boolean => {
		return skipped.has(step);
	};

	const handleNext = () => {
		let newSkipped = skipped;
		if (isStepSkipped(activeStep)) {
			newSkipped = new Set(newSkipped.values());
			newSkipped.delete(activeStep);
		}

		setActiveStep((prevActiveStep) => prevActiveStep + 1);
		setSkipped(newSkipped);
	};

	const handleBack = () => {
		setActiveStep((prevActiveStep) => prevActiveStep - 1);
	};

	const handleReset = () => {
		history.push(window.location.pathname);
		window.location.reload();
	};

	const updateQuiz = (e: ChangeEvent<HTMLInputElement>) => {
		const name = e.target.name;
		const value = e.target.value;

		setQuizDataEdit((prev) => ({ ...prev, [name]: value }));
	};

	useEffect(() => {
		if (quizId && course) setActiveStep(1);
	}, [quizId, course]);

	// update course state of react select
	useEffect(() => {
		let course_id = urlParams.current.get("courseId");
		if (course_id) {
			let selected_course = courses.filter(
				(val) => val.value === course_id
			)[0];
			console.log(selected_course);
			setCourse(selected_course);
		}
	}, [urlParams, courses]);

	// update examId state of react select
	useEffect(() => {
		let exam_id = urlParams.current.get("examId");
		if (exam_id) {
			let selected_exam = quizData.filter(
				(val) => val.value === exam_id
			)[0];
			setQuizId(selected_exam);
		}
	}, [urlParams, quizData]);

	// select course
	useEffect(() => {
		const controller = new AbortController();

		developAxios(localStorage.getItem("token") || "")
			.get<{
				courses: Array<{
					_id: string;
					name: string;
				}>;
			}>("/getallcourse", {
				signal: controller.signal,
			})
			.then(({ data }) => {
				setCourses(
					data.courses.map((val) => ({
						value: val._id,
						label: val.name,
					}))
				);
			})
			.catch((err) => console.log(err?.response));

		return () => controller.abort();
	}, []);

	// fetch quize data
	useEffect(() => {
		if (!course) return;
		developAxios(localStorage.getItem("token") || "")
			.get<{
				data: Array<IQuizData>;
			}>("/getquizexamsbycourse/" + course.value)
			.then(({ data }) => {
				setQuizData(
					data.data.map((val) => ({
						label: val.examName,
						value: val._id,
					}))
				);
			})
			.catch((err) => {
				console.log("err", err);
			});
	}, [course]);

	useEffect(() => {
		if (!quizId) return;
		developAxios(localStorage.getItem("token") || "")
			.get<{ data: IQuizData }>(
				"/admin/quiz/getQuizExamById/" + quizId.value
			)
			.then(({ data }) => {
				let { data: quiz_data } = data;
				setQuizDataEdit({
					...quiz_data,
					examDate: quiz_data.examDate
						? new Date(quiz_data.examDate)
								.toISOString()
								.slice(0, 16)
						: undefined,
					examEndTime: quiz_data.examEndTime
						? new Date(quiz_data.examEndTime)
								.toISOString()
								.slice(0, 16)
						: undefined,
				});
				setQuizQuestions(data.data.questions);

				let lang = data.data.language;

				// converts it to a boolean value
				if (!!lang) {
					// @ts-ignore
					if (lang === "") {
						setLanguage({
							value: "",
							label: "No language selected",
						});
					} else {
						console.log("reached here");
						setLanguage({ value: lang, label: lang });
					}
				}
			})
			.catch((err) => {
				console.log(err);
			});
	}, [quizId]);

	const {
		data: Questions,
		isLoading: questionsLoading,
		isError: questionsError,
		refetch: refetchQuizQuestions,
	} = useQuery(
		["get-question-schema", currPage],
		() => {
			return developAxios(localStorage.getItem("token") || "").get<{
				data: Array<{
					_id: string;
					question: string;
					topic: string;
				}>;
			}>("/getQuestionSchema", {
				params: {
					page: currPage,
					limit: 30,
					filter: searchFilter,
				},
			});
		},
		{
			enabled: currPage === 0 ? true : !!currPage,
		}
	);

	const handleSubmit = () => {
		if (!quizId) {
			alert("Go to step 1 and select a quiz exam");
			return;
		}
		let quiz_data: any = {
			attempts: quizDataEdit.attempts,
			category: quizDataEdit.category,
			company: quizDataEdit.company,
			description: quizDataEdit.description,
			examName: quizDataEdit.examName,
			timer: quizDataEdit.timer,
			typeOfExam: quizDataEdit.typeOfExam,
			courseId: quizDataEdit.courseId,
			locked: quizDataEdit.locked,
			outOfScore: quizDataEdit.outOfScore,
			questions: quizQuestions,
			displayResult: quizDataEdit.displayResult,
		};
		let { examDate, examEndTime } = quizDataEdit;
		if (examDate) {
			quiz_data = {
				...quiz_data,
				examDate: new Date(examDate).getTime(),
			};
		}
		if (examEndTime) {
			quiz_data = {
				...quiz_data,
				examEndTime: new Date(examEndTime).getTime(),
			};
		}
		developAxios(localStorage.getItem("token") || "")
			.post("/update-quiz-exam/" + quizId.value, quiz_data)
			.then(({ data }) => {
				handleNext();
				Store.addNotification({
					title: "Quiz Data Update",
					message: "successfuly updated",
					type: "success",
					insert: "top",
					container: "top-right",
					animationIn: ["animate__animated", "animate__fadeIn"],
					animationOut: ["animate__animated", "animate__fadeOut"],
					dismiss: {
						duration: 5000,
						onScreen: true,
					},
				});
			})
			.catch((err) => {
				Store.addNotification({
					title: "Error",
					message: "Error Occured in Submittion",
					type: "danger",
					insert: "top",
					container: "top-right",
					animationIn: ["animate__animated", "animate__fadeIn"],
					animationOut: ["animate__animated", "animate__fadeOut"],
					dismiss: {
						duration: 5000,
						onScreen: true,
					},
				});
				console.log(err);
			});
	};

	function handleExamClone() {
		history.push("/quiz-form-edit/creating-an-quiz-exam", {
			...quizDataEdit,
			questions: quizQuestions,
		});
	}

	function handleQuizQuestionsChange(id: string) {
		setClicked((prev) => {
			if (prev) {
				return !prev;
			}
			return prev;
		});
		setQuizQuestions((prev) => {
			if (prev.includes(id)) {
				return prev.filter((val) => val !== id);
			}
			let temp = [...prev];
			temp.push(id);
			return temp;
		});
	}

	function handleValueChange(
		e: SingleValue<{ value: string; label: string }>,
		type: "course" | "examId"
	) {
		if (!e) return;
		if (type === "course") {
			let course_id = urlParams.current.get("courseId");
			if (!course_id) {
				urlParams.current.append("courseId", e.value);
			} else {
				urlParams.current.set("courseId", e.value);
			}
			setCourse(e);
		}
		if (type === "examId") {
			let exam_id = urlParams.current.get("examId");
			if (!exam_id) {
				urlParams.current.append("examId", e.value);
			} else {
				urlParams.current.set("examId", e.value);
			}
			setQuizId(e);
		}
		history.replace({
			pathname: location.pathname,
			search: urlParams.current.toString(),
		});
	}
	const dateFormatToLocal = (date: string | undefined): string => {
		if (!date) return "";
		const backendDateUtc = moment.utc(date);
		const indianTime = backendDateUtc.clone().tz("Asia/Kolkata");
		const formattedIndianDate = indianTime.format("YYYY-MM-DDTHH:mm");
		return formattedIndianDate;
	};
	useEffect(() => {
		setQuizDataEdit((prev) => ({
			...prev,
			examDate: dateFormatToLocal(prev.examDate),
			examEndTime: dateFormatToLocal(prev.examEndTime),
		}));
	}, [quizDataEdit._id]);

	return (
		<Box sx={{ width: "65%", margin: "auto" }}>
			{/* TODO: input attempts, displayResult needs to be added */}

			{clicked && (
				<ContextMenu $top={points.y} $left={points.x}>
					<ul>
						<li
							onClick={() => {
								window.open("/quizEditform/" + points.id);
							}}
						>
							Edit
						</li>
					</ul>
				</ContextMenu>
			)}

			<Stepper activeStep={activeStep}>
				{steps.map((label, index) => {
					const stepProps: {
						completed?: boolean;
					} = {};
					const labelProps = {};

					if (isStepSkipped(index)) {
						stepProps["completed"] = false;
					}
					return (
						<Step key={label} {...stepProps}>
							<StepLabel {...labelProps}>{label}</StepLabel>
						</Step>
					);
				})}
			</Stepper>
			{activeStep === steps.length ? (
				<Fragment>
					<Typography sx={{ mt: 2, mb: 1 }}>
						All steps completed - you&apos;re finished
					</Typography>
					<Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
						<Box sx={{ flex: "1 1 auto" }} />
						<Button onClick={handleReset}>Reset</Button>
					</Box>
				</Fragment>
			) : (
				<Fragment>
					{activeStep === 0 && (
						<>
							<div style={{ marginTop: "85px" }}>
								<h5>Course ID:</h5>{" "}
								<Select
									value={course}
									onChange={(e) =>
										handleValueChange(e, "course")
									}
									// @ts-ignore
									options={courses}
									closeMenuOnSelect={true}
								/>
								<br />
								<h5>Quiz ID:</h5>
								<Select
									value={quizId}
									onChange={(e) =>
										handleValueChange(e, "examId")
									}
									// @ts-ignore
									options={quizData}
									closeMenuOnSelect={true}
								/>
								{/* <select
									// className="w-50"
									aria-label="Default select example"
									name="Quiz_select"
									id="Quiz_select"
									onChange={(e) => {
										setQuizId(e.target.value);
									}}
								>
									<option value="">Select Quiz</option>
									{quizData.map((val) => (
										<option value={val._id} key={val._id}>
											{val.examName}
										</option>
									))}
								</select> */}
							</div>
							<br />
						</>
					)}
					{activeStep === 1 && (
						<>
							<button
								className="rounded bg-blue-600 text-white px-5 py-3 my-2 hover:bg-blue-700"
								onClick={handleExamClone}
							>
								Clone Exam
							</button>
							<div className="quizForm">
								{" "}
								<div className="form-group">
									<label> ExamName </label>{" "}
									<input
										className="form-control"
										type="text"
										name="examName"
										value={quizDataEdit.examName}
										onChange={updateQuiz}
									/>
								</div>
								<br />
								<div className="form-group">
									<label>Category</label>{" "}
									<input
										className="form-control"
										type="text"
										name="category"
										value={quizDataEdit.category}
										onChange={updateQuiz}
									/>
								</div>
								<br />
								<div className="form-group">
									<label>Company</label>
									<input
										className="form-control"
										type="text"
										name="company"
										value={quizDataEdit.company}
										onChange={updateQuiz}
									/>
								</div>
								<br />
								<div className="form-group">
									<label> Description </label>{" "}
									<input
										className="form-control"
										type="text"
										name="description"
										value={quizDataEdit.description}
										onChange={updateQuiz}
									/>
								</div>
								<br />
								{/* <div className='from-group'>
                 
								{/* <br /> */}
								<div className="form-group">
									<label> Timer </label>{" "}
									<input
										className="form-control"
										type="number"
										name="timer"
										value={quizDataEdit.timer}
										onChange={updateQuiz}
									/>
								</div>
								<br />
								{/* </div> */}
								{/* <br /> */}
								<div className="form-group">
									<label> TypeOfExam </label>{" "}
									<select name="" id="">
										<option value="assignment">
											assignment
										</option>
										<option value="Test">Test</option>
									</select>
								</div>
								<div className="form-group">
									<label>Select Aptitude Type</label>
									<Select
										options={languageValues}
										value={language}
										onChange={(e) => setLanguage(e)}
									/>
								</div>
								<br />
								<div className="form-group">
									<label htmlFor="">OutOfScore</label>
									<input
										value={quizDataEdit.outOfScore}
										className="form-control"
										readOnly={true}
									/>
								</div>{" "}
								<br />
								<div className="form-group">
									<label htmlFor="">Exam Start Date:</label>{" "}
									<input
										type="datetime-local"
										value={quizDataEdit.examDate}
										onChange={(e) =>
											setQuizDataEdit((prev) => {
												return {
													...prev,
													examDate: e.target.value,
												};
											})
										}
									/>
								</div>{" "}
								<br />
								<div className="form-group">
									<label htmlFor="">Exam End Date:</label>{" "}
									<input
										type="datetime-local"
										value={quizDataEdit.examEndTime}
										onChange={(e) =>
											setQuizDataEdit((prev) => {
												return {
													...prev,
													examEndTime: e.target.value,
												};
											})
										}
									/>
								</div>{" "}
								<br />
								<div className="form-check mb-3">
									<input
										type="checkbox"
										checked={quizDataEdit.locked}
										className="form-check-input"
										id="exampleCheck1"
										onChange={(e) => {
											setQuizDataEdit((prev) => ({
												...prev,
												locked: !prev.locked,
											}));
										}}
									/>
									<label
										className="form-check-label"
										htmlFor="exampleCheck1"
									>
										Locked
									</label>
								</div>
								<div className="form-check mb-3">
									<input
										type="checkbox"
										checked={quizDataEdit.displayResult}
										className="form-check-input"
										id="displayResultCheck"
										onChange={(e) => {
											setQuizDataEdit((prev) => ({
												...prev,
												displayResult:
													!prev.displayResult,
											}));
										}}
									/>
									<label
										className="form-check-label"
										htmlFor="displayResultCheck"
									>
										Display Result
									</label>
								</div>
								<div className="form-check mb-3 flex gap-4">
									<input
										type="text"
										placeholder="Search by topic name"
										value={searchFilter}
										onChange={(e) =>
											setSearchFilter(e.target.value)
										}
									/>
									<Button
										variant="contained"
										onClick={() => refetchQuizQuestions()}
									>
										Search
									</Button>
								</div>
								<table
									data-toggle="table"
									className="table table-hover"
								>
									<thead className="thead-dark">
										<tr>
											<th className="text-dark ">S.No</th>

											<th className="text-dark text-left">
												Questions
											</th>
											<th className="text-dark text-left">
												Topic
											</th>
										</tr>
									</thead>
									<tbody>
										{Questions &&
											!questionsLoading &&
											!questionsError &&
											Questions.data.data.map(
												(value, index) => {
													return (
														<tr
															key={value._id}
															style={{
																background:
																	quizQuestions.includes(
																		value._id
																	)
																		? "grey"
																		: undefined,
																textAlign:
																	"left",
															}}
															onClick={() =>
																handleQuizQuestionsChange(
																	value._id
																)
															}
															onContextMenu={(
																e
															) => {
																e.preventDefault();

																setClicked(
																	(prev) =>
																		!prev
																);

																setPoints({
																	x: e.pageX,
																	y: e.pageY,
																	id: value._id,
																});
															}}
														>
															<td>
																{30 * currPage +
																	index +
																	1}
															</td>
															<td>
																{value.question}
															</td>
															<td>
																{value.topic}
															</td>
														</tr>
													);
												}
											)}
									</tbody>
								</table>
								<Pagination
									style={{
										justifyContent: "center",
									}}
								>
									{currPage !== 0 && (
										<Pagination.Prev
											onClick={() =>
												setCurrPage((prev) => --prev)
											}
										/>
									)}
									<Pagination.Item active={true}>
										{currPage + 1}
									</Pagination.Item>
									<Pagination.Next
										onClick={() =>
											setCurrPage((prev) => ++prev)
										}
									/>
								</Pagination>
							</div>
						</>
					)}

					<Box
						sx={{
							display: "flex",
							padding: "10px 0px",
							flexDirection: "row",
							pt: 2,
						}}
					>
						<button
							color="inherit"
							className="quizeditorBackbtn"
							disabled={activeStep === 0}
							onClick={handleBack}
							// sx={{ mr: 1 }}
						>
							Back
						</button>
						<Box sx={{ flex: "1 1 auto" }} />
						{activeStep === steps.length - 1 ? (
							<button
								className="quizeditorNextbtn"
								onClick={handleSubmit}
							>
								Submit
							</button>
						) : (
							<button
								color="inherit"
								className="quizeditorBackbtn"
								onClick={handleNext}
							>
								Next
							</button>
						)}
					</Box>
				</Fragment>
			)}
		</Box>
	);
};

export default QuizEditPage;
